<div class="auth-split">
  <!-- Left brand panel (hidden on small screens) -->
  <aside class="brand-panel">
    <div class="brand-panel-inner">
      <div class="brand-badge-wrapper">
        <span class="brand-pill">✨ SEÑALIZACIÓN DIGITAL INTELIGENTE</span>
      </div>

      <h1 class="brand-panel-title">Transformá tus pantallas en canales de venta</h1>
      <p class="brand-panel-sub">Programá videos, promociones y menús dinámicos en tiempo real desde cualquier lugar.</p>

      <ul class="brand-panel-benefits">
        <li>
          <div class="benefit-icon-wrap">
            <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
          </div>
          <div>
            <strong>Control total en la nube</strong>
            <span>Actualizá precios y contenido en segundos</span>
          </div>
        </li>
        <li>
          <div class="benefit-icon-wrap">
            <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
          </div>
          <div>
            <strong>Multi-pantallas simultáneas</strong>
            <span>Agrupá pantallas por sucursal o sector</span>
          </div>
        </li>
        <li>
          <div class="benefit-icon-wrap">
            <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/></svg>
          </div>
          <div>
            <strong>7 días de prueba completa</strong>
            <span>Sin costo ni compromiso, sin tarjeta requerida</span>
          </div>
        </li>
      </ul>

      <!-- Interactive CSS Player Showcase Mockup -->
      <div class="player-mockup">
        <div class="player-topbar">
          <div class="player-controls">
            <span class="ctrl-dot red"></span>
            <span class="ctrl-dot yellow"></span>
            <span class="ctrl-dot green"></span>
          </div>
          <div class="player-title">Pantalla 1 · Salón Principal</div>
          <div class="player-live-badge">
            <span class="live-pulse"></span>
            <span>EN VIVO</span>
          </div>
        </div>

        <div class="player-screen">
          <div class="screen-content">
            <div class="screen-hero">
              <span class="screen-tag">MENÚ DEL DÍA</span>
              <h3 class="screen-heading">Combo Gourmet Especial</h3>
              <p class="screen-desc">Hamburguesa Angus + Papas Rústicas + Bebida</p>
              <div class="screen-price-tag">
                <span class="price-curr">$</span><span class="price-val">12.500</span>
              </div>
            </div>
            <div class="screen-badge-overlay">
              <span class="badge-icon">⏱</span>
              <span>Rotación cada 15s</span>
            </div>
          </div>
          <div class="screen-playlist-bar">
            <div class="playlist-item active">Promo Almuerzo</div>
            <div class="playlist-item">Video Institucional</div>
            <div class="playlist-item">Postres & Café</div>
          </div>
        </div>
      </div>

      <div class="brand-trust-footer">
        <div class="trust-stars">★★★★★</div>
        <p class="trust-text">Más de 500 empresas ya impulsan sus ventas con Captar Media</p>
      </div>
    </div>
  </aside>

  <!-- Right interaction panel -->
  <main class="form-panel">
    <div class="form-panel-body">
      <div class="form-panel-content">
        <!-- Brand logo -->
        <div class="form-header-wrap">
          <img class="form-panel-logo" src="assets/img/captarmedia-login.png" alt="Captar Media">
        </div>



        <div *ngIf="errorMsg" class="mb-3">
          <ngb-alert type="danger" (close)="errorMsg = null">
            <strong>{{ errorMsg }}</strong>
          </ngb-alert>
        </div>

        <!-- VIEW 1: ACCOUNT -->
        <div *ngIf="currentStep === WizardStep.DATOS" class="wizard-step-view">
          <div class="view-header">
            <h2 class="view-title">Creá tu cuenta gratis</h2>
            <p class="view-subtitle">Empezá a gestionar tus pantallas en menos de 2 minutos</p>
          </div>

          <form [formGroup]="form" novalidate>
            <div class="form-group">
              <label for="wizardName">Nombre completo o Empresa</label>
              <div class="input-wrap">
                <span class="input-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                </span>
                <input id="wizardName" formControlName="name" type="text" class="form-control" placeholder="Ej: Juan Pérez o Mi Empresa S.A.">
              </div>
              <small class="form-error-text" *ngIf="form.get('name').touched && form.get('name').hasError('required')">
                <span class="error-dot">●</span> El nombre es requerido
              </small>
            </div>

            <div class="form-group">
              <label for="wizardEmail">Correo electrónico</label>
              <div class="input-wrap">
                <span class="input-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                </span>
                <input id="wizardEmail" formControlName="email" type="email" class="form-control" placeholder="tu@empresa.com">
              </div>
              <small class="form-error-text" *ngIf="form.get('email').touched && form.get('email').hasError('required')">
                <span class="error-dot">●</span> El email es requerido
              </small>
              <small class="form-error-text" *ngIf="form.get('email').touched && form.get('email').hasError('email')">
                <span class="error-dot">●</span> Ingresá un correo electrónico válido
              </small>
            </div>

            <div class="form-group">
              <label for="wizardPassword">Contraseña</label>
              <div class="input-wrap password-wrap">
                <span class="input-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                </span>
                <input id="wizardPassword" formControlName="password" [type]="showPassword ? 'text' : 'password'" class="form-control" placeholder="Mínimo 6 caracteres">
                <button type="button" class="password-toggle" (click)="togglePassword()" [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                  <svg *ngIf="!showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                  </svg>
                  <svg *ngIf="showPassword" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                </button>
              </div>
              <small class="form-error-text" *ngIf="form.get('password').touched && form.get('password').hasError('required')">
                <span class="error-dot">●</span> La contraseña es requerida
              </small>
              <small class="form-error-text" *ngIf="form.get('password').touched && form.get('password').hasError('minlength')">
                <span class="error-dot">●</span> Debe tener al menos 6 caracteres
              </small>
            </div>

            <button type="button" class="btn-cta" (click)="next()" [disabled]="isLoading">
              <span *ngIf="!isLoading">Continuar al paso siguiente</span>
              <span *ngIf="isLoading"><span class="btn-spinner"></span> Creando tu cuenta...</span>
            </button>

            <div class="trust-notice">
              <svg viewBox="0 0 20 20" fill="currentColor" class="trust-lock"><path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"/></svg>
              <span>Tus datos están protegidos y no compartimos tu información.</span>
            </div>

            <p class="form-switch">¿Ya tenés cuenta? <a routerLink="/login" class="form-switch-link">Iniciá sesión</a></p>
          </form>
        </div>

        <!-- VIEW 2: PLAN + PROVIDER -->
        <div *ngIf="currentStep === WizardStep.PLAN" class="wizard-step-view">
          <div class="view-header">
            <h2 class="view-title">Elegí el plan para tu negocio</h2>
            <p class="view-subtitle">Sin permanencia ni contratos forzados. Podés cambiar o cancelar cuando quieras.</p>
          </div>

          <div *ngIf="loadingPlans" class="text-center py-5">
            <div class="btn-spinner dark mb-2"></div>
            <p class="text-muted">Cargando planes disponibles...</p>
          </div>

          <div *ngIf="!loadingPlans && plansLoadError" class="text-center py-4 error-card">
            <p class="text-danger">{{plansLoadError}}</p>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="retryPlans()">Reintentar carga</button>
          </div>

          <div *ngIf="!loadingPlans && !plansLoadError">
            <!-- Billing cycle segmented switch -->
            <div class="billing-container">
              <div class="billing-tabs" role="group" aria-label="Elegí el ciclo de facturación">
                <button type="button" class="billing-tab" [class.active]="billingCycle==='mensual'" (click)="switchBillingCycle('mensual')" [attr.aria-pressed]="billingCycle==='mensual'">
                  Facturación Mensual
                </button>
                <button type="button" class="billing-tab" [class.active]="billingCycle==='anual'" (click)="switchBillingCycle('anual')" [attr.aria-pressed]="billingCycle==='anual'">
                  Facturación Anual
                  <span class="discount-pill">20% OFF</span>
                </button>
              </div>
              <p class="billing-note" aria-live="polite">
                {{billingCycle==='anual' ? 'Precio mensual equivalente, con facturación anual por adelantado. Ahorrás un 20%.' : 'Precios por pantalla, con facturación mensual. Podés cancelar cuando quieras.'}}
              </p>
            </div>

            <div class="trial-banner">
              <span class="trial-banner-badge">✓ 1 semana gratis</span>
              <p class="trial-banner-text">Probá <strong>7 días completos</strong> con todas las funciones del plan. Sin tarjeta y sin compromiso.</p>
            </div>

            <!-- Pricing cards grid: selfServe plans only (T3); bullets come from feature flags -->
            <div class="pricing-cards-grid">
              <div *ngFor="let plan of filteredPlans" class="pricing-card" [class.popular]="plan.popular" [class.selected]="selectedPlan && (selectedPlan.planId || selectedPlan.id) === (plan.planId || plan.id)" (click)="selectPlan(plan.planId || plan.id)" tabindex="0" role="button" [attr.aria-pressed]="selectedPlan && (selectedPlan.planId || selectedPlan.id) === (plan.planId || plan.id)">
                <div class="card-highlight-badge popular" *ngIf="plan.popular">Más elegido</div>
                <div class="card-header-inner">
                  <div class="plan-header-title">{{ plan.planName || plan.name }}</div>
                  <p class="plan-tagline">{{ taglineForPlan(plan) }}</p>
                  <div class="plan-price-block">
                    <span class="price-symbol">$</span>
                    <span class="price-main">{{ priceDisplay(plan) }}</span>
                    <span class="price-currency">{{ plan.currency }}</span>
                    <span class="price-period">/ mes{{ (plan.billing || billingCycle)==='anual' ? ' · facturado anual' : '' }}</span>
                  </div>
                  <div *ngIf="(plan.billing || billingCycle)==='anual'" class="plan-equiv-badge">
                    Facturado anual: <strong>${{ annualTotal(plan) }} {{ plan.currency }}/año</strong>
                  </div>
                  <div *ngIf="(plan.billing || billingCycle)!=='anual'" class="plan-sub-badge">Primera semana gratis</div>
                </div>

                <div class="card-features">
                  <div *ngFor="let feat of featuresForPlan(plan)" class="feature-line" [class.not-included]="!feat.included">
                    <span class="feat-check" *ngIf="feat.included">✓</span>
                    <span class="feat-cross" *ngIf="!feat.included">✕</span>
                    <span>{{ feat.text }}</span>
                  </div>
                </div>

                <div class="card-action">
                  <div class="selection-pill" [class.active]="selectedPlan && (selectedPlan.planId || selectedPlan.id) === (plan.planId || plan.id)">
                    <span *ngIf="selectedPlan && (selectedPlan.planId || selectedPlan.id) === (plan.planId || plan.id)">✓ Seleccionado</span>
                    <span *ngIf="!selectedPlan || (selectedPlan.planId || selectedPlan.id) !== (plan.planId || plan.id)">Elegir este plan</span>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="filteredPlans.length===0" class="text-center mt-3">
              <p class="text-muted">No hay planes disponibles para este ciclo.</p>
            </div>

            <div class="payment-guarantee-note" *ngIf="selectedPlanMode==='trial'">
              <svg viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
              <span>Sin cargo hoy. Sin tarjeta. No se te cobrará nada durante el período de prueba.</span>
            </div>
          </div>

          <div class="wizard-actions">
            <button type="button" class="btn-cta" (click)="next()" [disabled]="isLoading">
              <span *ngIf="!isLoading">{{selectedPlanMode==='trial' ? 'Comenzar mi prueba gratis' : 'Continuar al pago'}}</span>
              <span *ngIf="isLoading"><span class="btn-spinner"></span> Procesando...</span>
            </button>
            <button type="button" class="btn-back" (click)="prev()">← Volver al paso anterior</button>
          </div>
        </div>

        <!-- SUCCESS -->
        <div *ngIf="currentStep === WizardStep.CONFIRM" class="wizard-step-view success-view">
          <div class="success-halo">
            <div class="success-icon-ring">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </div>
          </div>

          <h2 class="success-title">¡Cuenta configurada con éxito!</h2>
          <p class="success-subtitle">Tu <strong>Pantalla 1</strong> ya está lista con contenido demostrativo.</p>
          <p class="success-plan-line" *ngIf="confirmedPlanName">7 días gratis de {{ confirmedPlanName }}</p>

          <div class="trial-status-pill">
            <span class="pulse-indicator"></span>
            <strong>{{ trialDaysRemaining }} días restantes</strong>
            <span class="status-detail" *ngIf="trialEndsAtLabel">· Activo hasta el {{ trialEndsAtLabel }}</span>
            <span class="status-detail" *ngIf="responseData?.subscriptionExpiresAt">· Vence el {{responseData.subscriptionExpiresAt | date:'dd/MM/yyyy'}}</span>
          </div>

          <!-- Quick start device box -->
          <div class="device-activation-box">
            <div class="activation-header">
              <h4 class="activation-title">Vincular tu primera pantalla</h4>
              <p class="activation-sub">Instalá la aplicación en tu Smart TV, TV Box o tablet Android:</p>
            </div>

            <div class="activation-body">
              <div class="qr-card">
                <img src="https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.captarmedia.player" alt="Código QR para descargar Captar App" class="qr-img">
                <span class="qr-caption">Escanear para descargar APK</span>
              </div>

              <ul class="steps-list">
                <li class="step-guide-item">
                  <span class="step-bullet">•</span>
                  <div class="step-txt">Descargá <strong>Captarmedia</strong> desde Google Play o con el código QR.</div>
                </li>
                <li class="step-guide-item">
                  <span class="step-bullet">•</span>
                  <div class="step-txt">Abrí la app e ingresa <strong>id circuito y id equipo</strong> recién creados.</div>
                </li>
                <li class="step-guide-item">
                  <span class="step-bullet">•</span>
                  <div class="step-txt">Tu <strong>Pantalla 1</strong> comenzará a reproducir automáticamente.</div>
                </li>
              </ul>
            </div>
          </div>

          <div class="success-actions">
            <button class="btn-cta" (click)="goToLogin()">Ingresar al Panel de Gestión</button>
            <p class="email-notice">Te enviamos los datos de confirmación a tu correo electrónico.</p>
          </div>
        </div>
      </div>
    </div>

    <footer class="form-panel-footer">
      <small class="footer-text">Captar Media · Plataforma de Señalización Digital</small>
    </footer>
  </main>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/register-wizard/register-wizard.component.html